import React from 'react';
import usePermissions from '../../hooks/usePermissions';

/**
 * Renders children only when the logged-in admin has the given permission
 * (or is a super_admin). Renders `fallback` otherwise (default: nothing).
 *
 * Props:
 *   permission {string}     permission key to check
 *   fallback   {ReactNode}  optional element shown when access is denied
 */
const PermissionGate = ({ permission, children, fallback = null }) => {
  const { can } = usePermissions();
  return can(permission) ? children : fallback;
};

export default PermissionGate;
